<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import WxMiniShare from '@/pages/ThemePage/mixins/wxMiniShare'
export default {
  name: 'app',
  mixins: [WxMiniShare]
}
</script>
<style lang="less">
html,
body,
#app {
  width: 100%;
  height: 100%;
}
</style>
